// extracted by mini-css-extract-plugin
module.exports = {"section":"Homepage_section__3pQYg","sectionTitle":"Homepage_sectionTitle__3A9Si","subTitle":"Homepage_subTitle__26ymW"};